/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum BuyerUserType {
    GREEK_ORGANIZATION = 'Greek Organization',
    UNIVERSITY_PROGRAM_BOARD = 'University Program Board',
    WEDDING = 'Wedding',
    CORPORATE_EVENT = 'Corporate Event',
    BAR = 'Bar',
    BREWERY = 'Brewery',
    RESTAURANT = 'Restaurant',
    NIGHTCLUB = 'Nightclub',
    COUNTRY_CLUB = 'Country Club',
    MUNICIPALITY = 'Municipality',
    OTHER = 'Other',
}